import { render } from "./EvaluationOfPatient.vue?vue&type=template&id=be9de15a&scoped=true&ts=true"
import script from "./EvaluationOfPatient.vue?vue&type=script&lang=ts"
export * from "./EvaluationOfPatient.vue?vue&type=script&lang=ts"

import "./EvaluationOfPatient.vue?vue&type=style&index=0&id=be9de15a&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/HeThongPVNB_HV/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9de15a"]])

export default __exports__